import { Link } from "react-router-dom";
import { Type } from "@themes/pollinator/ui/Type";

export type Props = {
  /** The timezone label to display */
  timezoneLabel?: string;
  /** URL to navigate to for editing profile */
  editProfileUrl?: string;
};

export function SchedulingTimezoneMessage({
  timezoneLabel,
  editProfileUrl = "/account",
}: Props) {
  return (
    <Type variant="body2" as="span">
      Meeting times are displayed in {timezoneLabel}.{" "}
      <Link to={editProfileUrl} className="underline">
        Edit your account settings
      </Link>{" "}
      to select a different timezone.
    </Type>
  );
}

export default SchedulingTimezoneMessage;
